import _orderBy from 'lodash/orderBy'

/**
 * @param   {object}   state
 *
 * @returns {object[]}
 */
const getStyles = state => state.styles

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getStylesByBoardId = state => id =>
  _orderBy(
    state.styles.filter(item => item.board_id === id),
    'index'
  )

/**
 * @param   {object}   state
 * @param   {number}   id
 *
 * @returns {Function}
 */
const getStyleById = state => id => state.styles.find(style => style.id === id)

/**
 * @param   {object} state
 * @param   {object} getters
 * @param   {number} styleId
 *
 * @returns {object}
 */
const getStylePreviewOption = (state, getters) => styleId => {
  const options = getters.getOptionsByStyleId(styleId)

  if (options.length > 0 && options[0].assets_file) {
    return options[0]
  } else {
    return null
  }
}

/**
 * @param   {object}   state
 * @param   {number}   groupId
 * @param   {number}   seasonId
 *
 * @returns {Function}
 */
const getCustomTags = state => (groupId, seasonId) =>
  state.customTags
    .filter(tag => tag.group_id === groupId && tag.season_id === seasonId)
    .sort((tag1, tag2) => tag1.text.localeCompare(tag2.text))

/**
 * @param   {object}   state
 * @param   {string}   text
 *
 * @returns {Function}
 */
const getCustomTagByText = state => text =>
  state.customTags.find(tag => tag.text === text)

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getStyleMetaFilters = state => state.styleMetaFilters

/**
 * @param   {object}   state
 *
 * @returns {Function}
 */
const getStyleHubFilters = state => state.styleHubFilters

/**
 * @param   {object}   state
 * @param   {string}   field
 * @param   {string}   value
 *
 * @returns {Function}
 */
const getStyleMetaFilterValue = state => (field, name) => {
  if (state.styleMetaFilters[field]) {
    return state.styleMetaFilters[field].values.find(
      value => value.name === name
    )
  }

  return null
}

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getStylesPaginatedPage = state => state.stylesPaginatedPage

/**
 * @param   {object} state
 *
 * @returns {number}
 */
const getStylesPaginatedLimit = state => state.stylesPaginatedLimit

/**
 * @param   {object}  state
 *
 * @returns {boolean}
 */
const getHasReachedStylesPaginatedEnd = state =>
  state.hasReachedStylesPaginatedEnd

/**
 * @type {object}
 */
const getters = {
  getStyles,
  getStylesByBoardId,
  getStyleById,
  getStylePreviewOption,
  getCustomTags,
  getCustomTagByText,
  getStyleMetaFilters,
  getStyleHubFilters,
  getStyleMetaFilterValue,
  getStylesPaginatedPage,
  getStylesPaginatedLimit,
  getHasReachedStylesPaginatedEnd
}

export default getters
